import React from 'react';
import '../styles/StaleActive.css';
import { Warning } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

// Mirrors Ceiling.js / Floor.js — orange banner saying "Stale listing"
// for active/pending listings the doubt layer pulled ARV down with.
// Same orange hue as the "Pulled down by N stale listing" pill on the
// Final ARV card so the colour reads as one signal in two places.
function StaleActive(props) {
    return (
        <div className="stale-active-element-container bg-colour-orange-01">
            <div className="stale-active-element-title-container">
                <Warning fill={colour.orange03} />
                <span className="body-bold colour-orange">
                    Stale listing
                </span>
            </div>
        </div>
    )
};

export default StaleActive;
